var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0 px-0 px-md-3"},[_c('swiper',{staticClass:"mb-4",attrs:{"options":_vm.carouselOption}},_vm._l((_vm.banners),function(banner,i){return _c('swiper-slide',{key:i},[_c('banner',{attrs:{"loading":_vm.loading,"banner":banner}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }